<template>
  <div class="text-center" style="background: white" :class="{loadingDisplay: $props.loadingStatus }" >
<!--    <img :src="require('@/assets/data_loading.webp')" alt="" class="loading-gif">-->

    <div class="spinner-border text-primary my-3" style="width: 3rem; height: 3rem;" role="status">
      <span class="sr-only">Loading...</span>
    </div>

    <h5 class="font-weight-bolder">Loading Please Wait . . . . .</h5>
  </div>
</template>

<script>
export default {
  name: "AppLoading2",
  props: ['loadingStatus']
}
</script>

<style scoped>
 .loadingDisplay {
   display: block;
 }
</style>
